import { GridColDef } from "@mui/x-data-grid";
import { Button, IconButton } from "@mui/material";

import DynamicIcon from "../../../../../../components/global/DynamicIcon";

/**
 * GenerateObrasColumnDefinition
 */

type Props = {
  onActionEditar: (idGestaodeResiduosObra: number | null, openState: boolean) => void;
  onActionDeletar: (idGestaodeResiduosObra: number | null, openState: boolean) => void;
  onActionDownload: (arquivoNome: string, arquivo: string) => void;
};

export const GenerateControleColumnDefinition = ({
  onActionEditar,
  onActionDeletar,
  onActionDownload,
}: Props): GridColDef[] => {
  return [
    {
      field: "classe",
      filterable: false,
      headerName: "Classe",
      minWidth: 75,
      width: 75,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex items-center text-center text-xs">
          {params.value}
        </div>
      ),
    },
    {
      field: "caracteristica",
      filterable: false,
      headerName: "Característica",
      flex: 1,
      minWidth: 150,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center text-center text-xs">
          {params.value}
        </div>
      ),
    },
    {
      field: "tipo",
      filterable: false,
      headerName: "Tipo",
      flex: 1,
      minWidth: 150,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center text-center text-xs">
          {params.value}
        </div>
      ),
    },
    {
      field: "formaSegregacao",
      filterable: false,
      headerName: "Forma de Segregação",
      flex: 1,
      minWidth: 150,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center text-center text-xs">
          {params.value}
        </div>
      ),
    },
    {
      field: "empresaGerenciadora",
      filterable: false,
      headerName: "Empresa Gerenciadora",
      flex: 1,
      minWidth: 150,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center text-center text-xs">
          {params.value}
        </div>
      ),
    },
    {
      field: "destinacaoFinal",
      filterable: false,
      headerName: "Destinação Final",
      flex: 1,
      minWidth: 150,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center text-center text-xs">
          {params.value}
        </div>
      ),
    },
    {
      field: "arquivo",
      filterable: false,
      headerName: "Arquivo",
      width: 175,
      sortable: false,
      resizable: false,
      valueGetter: (_, rows) => ({
        nomeArquivo: rows["nomeArquivo"],
        arquivo: rows["arquivo"],
      }),
      renderCell: (params) => {
        const maxSize = 20;
        const nomeArquivo = params.value["nomeArquivo"] as string;
        const arquivo = params.value["arquivo"] as string;

        return (
          <div className="w-full h-full flex justify-center items-center text-center">
            <Button
              onMouseDown={() => onActionDownload(nomeArquivo, arquivo)}
              sx={{
                fontSize: 11,
                paddingX: ".4rem",
                paddingY: 0,
                background: "#e6e6e6",
                borderLeft: ".3rem solid #45b6af",
                borderRadius: 0,
                color: "black",
                fontWeight: "normal",
                width: "9.5rem",
              }}>
              {nomeArquivo && nomeArquivo.length > maxSize
                ? `${nomeArquivo.substring(0, maxSize)}...`
                : nomeArquivo}
            </Button>
          </div>
        );
      },
    },
    {
      field: "idGestaoResiduos",
      headerName: "Ações",
      sortable: false,
      filterable: false,
      width: 100,
      renderCell: (params) => (
        <div className="flex items-center justify-center w-full h-full gap-2">
          <IconButton onClick={() => onActionEditar(params.row.idGestaoResiduos, true)}>
            <DynamicIcon
              nameIcon="EditRounded"
              size={25}
              className="dark:text-white text-primary-green"
            />
          </IconButton>

          <IconButton onClick={() => onActionDeletar(params.row.idGestaoResiduos, true)}>
            <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
          </IconButton>
        </div>
      ),
    },
  ];
};
